export default __webpack_public_path__ + "static/media/e.cb05e5a0.jpg";